<template>
  <el-container class="container">
    <el-header class="header" height="30px">
      <div class="back" @click="$router.push('/')">
        <el-icon class="el-icon-arrow-left"></el-icon>
        <span>返回主页</span>
      </div>
    </el-header>
    <el-container class="main-content">
      <el-aside width="200px" class="aside-left">
        <left-menu></left-menu>
      </el-aside>

      <el-main class="main" id="layout-main">
        <MenuNavigation></MenuNavigation>
        <div class="main-content">
          <keep-alive :include="keepAlive">
            <!-- 需要缓存的视图组件 -->
            <router-view></router-view>
          </keep-alive>
          <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LeftMenu from './LeftMenu.vue'
import MenuNavigation from './MenuNavigation.vue'
export default {
  name: 'Layout',
  components: {
    LeftMenu,
    MenuNavigation
  },
  data () {
    return {}
  },
  computed: {
    keepAlive () {
      return this.$store.state.keepAlive
    }
  },
  watch: {
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss">
  ::v-deep .el-card{
    height: 100%;
    overflow: auto;
  }
</style>
<style scoped lang="scss">
.el-container{
  height: calc(100vh - 62px);
}
.container {
  height: 100%;
}
.header {
  height: 32px;
  padding: 0;
  user-select: none;
  background: url('../../assets/img/header_bg.png') no-repeat center bottom /cover;
  background-size: 100% 200%;
}
.aside-left {
  background: #EFF7FF;
  box-shadow: 1px 0px 2px 0px rgb(199 199 199 / 77%);
  background: url('../../assets/img/setting-menu-bg.png') no-repeat center bottom /cover;
  margin-top: -2px;
}

.el-main {
  margin-top: -2px;
  padding: 0;
  background: #F5F6FA;
  .main-content {
    padding: 20px;
    height: 100%;
  }
}
.back{
  width: 200px;
  height: 30px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  line-height: 30px;
  padding-left: 10px;
  cursor: pointer;
  i{
    margin-right: 5px;
  }
}
</style>
